import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { StripeProvider } from "../context/StripeContext";
import { ErrorReportProvider, useErrorReport } from "../context/ErrorReportContext";
import { EmailVerificationProvider } from "../components/auth/EmailVerificationProvider";
import { SubscriptionProvider } from "../hooks/useSubscriptionAccess";
import { Outlet } from "react-router";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import AppSidebar from "./AppSidebar";
import ConnectionStatus from "../components/common/ConnectionStatus";
import PWAInteractionTracker from "../components/pwa/PWAInteractionTracker";
import MobileFooter from "../components/layout/MobileFooter";
import ErrorReportModal from "../components/ErrorReport/ErrorReportModal";
import OnboardingProgressToast from "../components/onboarding/OnboardingProgressToast";
import NextStepIndicator from "../components/onboarding/NextStepIndicator";
import MobileCommandSearch from "../components/header/MobileCommandSearch";
import { AccountSummaryProvider } from "../context/AccountSummaryContext";
import { QuickAddServiceProvider } from "../context/QuickAddServiceContext";

const LayoutContent: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const { isModalOpen, closeModal } = useErrorReport();

  return (
    <div className="h-screen flex xl:flex-row flex-col bg-gray-50 dark:bg-gray-900">
      <ConnectionStatus />
      <div className="xl:relative">
        <AppSidebar />
        <Backdrop />
      </div>
      <div
        className={`flex-1 flex flex-col transition-all duration-300 ease-in-out overflow-hidden ${
          isExpanded || isHovered ? "lg:ml-[280px]" : "lg:ml-[80px]"
        } ${isMobileOpen ? "ml-0" : ""}`}
      >
        {/* Fixed Header */}
        <div className="flex-shrink-0">
          <AppHeader />
        </div>
        
        {/* Scrollable Content Area */}
        <PWAInteractionTracker>
          <div className="flex-1 overflow-y-auto p-4 mx-auto w-full max-w-none md:max-w-[var(--breakpoint-2xl)] md:p-6 pb-20 lg:pb-4 bg-gray-50 dark:bg-gray-900">
            <Outlet />
          </div>
        </PWAInteractionTracker>
      </div>

      {/* Mobile Footer Navigation - Fixed at bottom */}
      <MobileFooter />

      {/* Buscador de comandos móvil (dentro del layout para ver los providers) */}
      <MobileCommandSearch />

      {/* Onboarding Components */}
      <OnboardingProgressToast />
      <NextStepIndicator />

      {/* Global Error Report Modal - Full Screen */}
      <ErrorReportModal
        isOpen={isModalOpen}
        onClose={closeModal}
      />
    </div>
  );
};

const AppLayout: React.FC = () => {
  return (
    <SidebarProvider>
      <StripeProvider>
        <SubscriptionProvider>
          <ErrorReportProvider>
            <EmailVerificationProvider>
              <AccountSummaryProvider>
                <QuickAddServiceProvider>
                  <LayoutContent />
                </QuickAddServiceProvider>
              </AccountSummaryProvider>
            </EmailVerificationProvider>
          </ErrorReportProvider>
        </SubscriptionProvider>
      </StripeProvider>
    </SidebarProvider>
  );
};

export default AppLayout;
